import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useUserFlows } from "./useUserFlows";
import { setOwnedSharedFlows } from "redux/actions/portal/flowsActionCreator";
import { useDispatch } from "react-redux";
import { usePortalFlows } from "./usePortalFlows";

export const useOwnedSharedFlows = (forced = false) => {
  const { user } = useAuth0();
  const { flows, areFlowsLoaded } = usePortalFlows();
  const { ownedSharedFlows } = useSelector((store) => store?.portal?.flows);
  const { userFlows } = useUserFlows();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!forced && !areFlowsLoaded) return;

    setIsLoading(false);
    const ownedFlows = flows.filter((flow) => flow.created_by_id === user.cxfUserId);
    const sharedToMeUserflows = userFlows
      ? userFlows.filter((userFlow) => userFlow.user_id === user.cxfUserId)
      : [];
    const mappedSharedUserflows = sharedToMeUserflows.map((flow) => flow.id);
    const sharedFlows = flows.filter((flow) => mappedSharedUserflows.includes(flow.id)) || [];
    let mergedArrayforOutput = [...ownedFlows, ...sharedFlows];

    mergedArrayforOutput.sort(
      (a, b) => new Date(b.updated_date_time) - new Date(a.updated_date_time)
    );
    mergedArrayforOutput = mergedArrayforOutput.filter((flow) => flow.trashed !== true).slice(0, 3);

    dispatch(setOwnedSharedFlows(mergedArrayforOutput));
  }, [flows, user, areFlowsLoaded]);

  return {
    ownedSharedFlows,
    isLoading,
  };
};
